import { mapGetters, mapState } from 'vuex';
import { navigateExternalURL } from '@/utils/urlHelper';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';
import Loading from '@/components/widgets/Loading/Loading.vue';

// @vue/component
export default {
  name: 'SAMLForm',
  components: {
    PageHeader,
    Loading,
  },
  data() {
    return {
      email: '',

      formError: '',
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line
      title: (state) => state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in',
      isIframe: (state) => state.login.meta.isIframe,
    }),
    ...mapGetters({
      samlURL: 'samlURL',
      allowStandardLogin: 'allowStandardLogin',
    }),
  },
  mounted() {
    if (this.isIframe) {
      window.parent.postMessage('pageResized', '*');
    }
  },
  methods: {
    onSubmit() {
      if (this.isLoading) return false;
      this.isLoading = true;
      return navigateExternalURL(this.samlURL, this.isIframe);
    },
    reload() {
      window.location.reload();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/sections/Login/SAMLStarter/SAMLStarter.js